import styled, { device, themeGet, keyframes } from "@theme/utils";
import bg from "../../data/images/working/circle-1.png";

const rotation = keyframes`
    from {
        -webkit-transform: rotate(0deg);
    }
    to {
        -webkit-transform: rotate(359deg);
    }
`;
export const ChooseList = styled.div`
    margin-bottom: 25px;
    display: flex;
    &:last-child {
        margin-bottom: 0;
    }
`;

export const Wrapper = styled.div`
    background-image: url(${bg});
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;

    position: absolute;
    background-repeat: no-repeat;
    background-size: cover;
    animation: ${rotation} 10s infinite linear;
`;

export const Icon = styled.div`
    background-color: white;
    position: relative;
    padding: 15px;
    /* background-repeat: no-repeat;
    background-size: cover; */
    box-shadow: 0px 15px 30px 0px rgb(2 18 106 / 5%);
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    width: 65px;
    height: 65px;
    margin-right: 20px;
    ${device.large} {
        width: 85px;
        height: 85px;
        margin-right: 40px;
    }
`;
export const ChooseListContent = styled.div`
    flex: 1;
`;
export const Title = styled.h5``;
export const DesText = styled.p``;
export const Rotation = styled.div`
    position: absolute;
    background-image: url(${bg});
    background-repeat: no-repeat;
    background-size: cover;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    span {
        animation: ${rotation} 10s infinite linear;
        position: relative;
        display: block;
        height: 100%;
        &::before,
        &::after {
            position: absolute;
            width: 8px;
            height: 8px;
            content: "";
            border-radius: 50%;
            background: ${themeGet("colors.gradient")};
        }
        &::before {
            left: 15px;
            bottom: 10px;
        }
        &::after {
            right: 15px;
            top: 10px;
        }
    }
    &.actionOne {
        span {
            &::before,
            &::after {
                background: -webkit-linear-gradient(
                    -45deg,
                    #fd4485 0%,
                    #ffa38d 100%
                );
            }
        }
    }
    &.actionTwo {
        span {
            &::before,
            &::after {
                background: -webkit-linear-gradient(
                    -45deg,
                    #fd6300 0%,
                    #ffe121 100%
                );
            }
        }
    }
    &.actionThree {
        span {
            &::before,
            &::after {
                background: -webkit-linear-gradient(
                    -45deg,
                    #505eff 0%,
                    #03bdff 100%
                );
            }
        }
    }
    &.actionFour {
        span {
            &::before,
            &::after {
                background: -webkit-linear-gradient(
                    -45deg,
                    #b241ff 0%,
                    #fe86ff 100%
                );
            }
        }
    }
`;

export const ServiceIcon = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: white;
    box-shadow: 0px 22px 35px 0px rgb(2 18 106 / 8%);
    min-width: 100px;
    height: 100px;
    margin-right: 25px;
    border-radius: 100%;
    ${device.xlarge} {
        min-width: 115px;
        height: 115px;
        margin-right: 50px;
    }
`;
